module.exports = __webpack_public_path__ + "09_hige_white.6c72d4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/09_hige_white.png
// module id = jwIN
// module chunks = 0